import { Dispatch, SetStateAction, useEffect } from 'react';

import { INITIAL_AUDIO_STATE, MIN_SEEK_VALUE } from '@/components/emotion-detector/AudioPlayer/constants';
import { CurrentAudio } from '@/components/emotion-detector/AudioPlayer/types';

interface UseDetectionResetProps {
	detecting: boolean;
	resetChat: () => void;
	resetCardsAfterCapture: () => void;
	currentAudio: CurrentAudio;
	setCurrentAudio: Dispatch<SetStateAction<CurrentAudio>>;
}

/**
 * Resets chat, cards, and audio when emotion detection starts
 */
export function useDetectionReset({
	detecting,
	resetChat,
	resetCardsAfterCapture,
	currentAudio,
	setCurrentAudio,
}: UseDetectionResetProps) {
	useEffect(() => {
		if (detecting) {
			resetChat();
			resetCardsAfterCapture();
			if (currentAudio.element) {
				currentAudio.element.pause();
				// TODO: refactor this code to follow best practices
				// eslint-disable-next-line react-hooks/immutability
				currentAudio.element.currentTime = MIN_SEEK_VALUE;
				setCurrentAudio(INITIAL_AUDIO_STATE);
			}
		}
	}, [detecting, resetChat, resetCardsAfterCapture, setCurrentAudio, currentAudio.element]);
}
